import React, { Component } from 'react';
import {Button, DatePickerView, Flex,List} from 'antd-mobile';

export default class DatePickerSE extends Component {
  constructor (props) {
    super(props);
    this.state = {
      value: new Date(),
      minDate: '2000-1-1',
      maxDate: '2030-1-1'
    }
  }
  onChange = (value) => {
    this.setState({value})
  };
  ok = () => {
    const {value} = this.state;
    typeof this.props.onConfirm === 'function' && this.props.onConfirm(value)
  };
  cancel = () => {
    typeof this.props.onCancel === 'function' && this.props.onCancel()
  };
  componentWillMount() {
    const {value, maxDate, minDate} = this.props;
    this.setState({
      value:value ? value : new Date(),
      maxDate:maxDate ? maxDate : new Date(2030, 0, 1),
      minDate:minDate ? minDate : new Date(2000, 0, 1)
    })
  }

  render() {
    const {value, minDate, maxDate} = this.state;
  return (
    <List>
      <DatePickerView
          maxDate={maxDate}
          minDate={minDate}
          mode={'date'}
          onChange={this.onChange}
          value={value}
      />
      <div style={{padding: '15px 10px'}}>
        <Flex>
          <Flex.Item>
            <Button onClick={this.cancel}>取消</Button>
          </Flex.Item>
          <Flex.Item>
            <Button onClick={this.ok}
                type="primary"
            >确定</Button>
          </Flex.Item>
        </Flex>
      </div>
    </List>
  )
 }
}
